export { SocietyInfoDetails as default } from './SocietyInfoDetails';
export type { societyFormValue } from './SocietyInfoDetails';